import 'isomorphic-fetch';
import {getConfigurationByEnv} from '../configs/models-carousel-configs';

export async function fetchLaunchDarklyClientConfig(
  baseUrl?: string,
): Promise<string> {
  const configJson = getConfigurationByEnv(baseUrl);
  const finalUrl = configJson.url.endsWith('/')
    ? `${configJson.url}launchDarklyConfig`
    : `${configJson.url}/launchDarklyConfig`;
  const response = await fetch(finalUrl);
  if (!response.ok) {
    throw new Error('Failed to fetch Launch Darkly Client API key');
  }

  const data = await response.json();
  const decodedString = atob(data.base64Encoded);
  const appConfig = JSON.parse(decodedString);

  configJson.launchDarklyClientKey = appConfig;

  return appConfig;
}
